<footer class="footer">
  <div class="footer-content">
    <div class="footer-section">
      <h3>Radio Ads Direct</h3>
      <p>Your Gateway to Effective Radio Advertising</p>
    </div>
    
    <div class="footer-section">
      <h4>Quick Links</h4>
      <ul class="footer-links">
        <li><a routerLink="/home">Home</a></li>
        <li><a routerLink="/login">Login</a></li>
        <li><a routerLink="/signup">Sign Up</a></li>
        <li><a routerLink="/userhome">Dashboard</a></li>
      </ul>
    </div>
    
    <div class="footer-section">
      <h4>Services</h4>
      <ul class="footer-links">
        <li><a routerLink="/recordnow">Record Audio</a></li>
        <li><a routerLink="/commercialform">Commercial Production</a></li>
        <li><a routerLink="/campaignbuilder">Campaign Builder</a></li>
        <li><a routerLink="/managecampaigns">Manage Campaigns</a></li>
      </ul>
    </div>
  </div>
  
  <div class="footer-bottom">
    <div class="footer-bottom-content">
      <p>&copy; {{ currentYear }} Radio Ads Direct. All rights reserved.</p>
    </div>
  </div>
</footer>
